import { useState } from "react";
import { useResults } from "./lib/ResultsContext";

var inputStyle = { width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,165,0,0.2)", borderRadius: 8, color: "#fff", padding: "10px 14px", fontSize: 14, outline: "none", fontFamily: "sans-serif" };

// Text field + filtered dropdown against the known player names.
// Every keystroke reports the raw typed text via onSelect too, so a name with
// no match still "selects" — clicking a suggestion just fills the same text.
export default function PlayerSearchInput(props) {
  var value = props.value || "";
  var onSelect = props.onSelect;
  var placeholder = props.placeholder || "Search player name...";
  var allPlayerNames = useResults().playerNames;
  var [open, setOpen] = useState(false);

  var trimmed = value.trim();
  var q = trimmed.toLowerCase();
  var matches = q
    ? allPlayerNames.filter(function(p) { return p.toLowerCase().indexOf(q) !== -1; }).slice(0, 8)
    : [];
  var exactMatch = trimmed !== "" && allPlayerNames.indexOf(trimmed) !== -1;

  return (
    <div style={{ position: "relative" }}>
      <input
        style={inputStyle}
        value={value}
        onChange={function(e) { onSelect(e.target.value); setOpen(true); }}
        onFocus={function() { setOpen(true); }}
        onBlur={function() { setTimeout(function() { setOpen(false); }, 150); }}
        placeholder={placeholder}
      />
      {open && matches.length > 0 && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#1a1a1a", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 6, maxHeight: 180, overflowY: "auto", zIndex: 200 }}>
          {matches.map(function(p) {
            return (
              <div key={p} onClick={function() { onSelect(p); setOpen(false); }} style={{ padding: "8px 12px", cursor: "pointer", color: "#ccc", fontSize: 14 }}>
                {p}
              </div>
            );
          })}
        </div>
      )}
      {trimmed !== "" && !exactMatch && (
        <div style={{ fontSize: 11, color: "#FFB020", marginTop: 5 }}>
          {matches.length > 0
            ? "No exact match — pick a name below or this will be saved as typed."
            : "No match in the results data — this will be saved as a brand new, unlinked name."}
        </div>
      )}
    </div>
  );
}
